<template>
    <v-container class="container" fluid>
        <v-data-table :headers="headers" :items="filteredItems" :search="search" class="elevation-10"
            :loading="dataLoading" :items-per-page="50" :footer-props="{
                'items-per-page-options': [10, 50, 100, -1]
            }" :sort-by="'ROHrs'" :sort-desc="false" loading-text="Loading... Please wait" height="60vh" fixed-header>
            <template v-slot:top>
                <v-card>
                    <v-toolbar dense dark color="secondary">
                        <v-spacer />
                        <v-toolbar-title class="white--text">Inventory Readings</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                            <v-col cols="3">
                                <v-card-title>
                                    <v-text-field v-model="search" label="Search" append-icon="mdi-magnify"
                                        dense></v-text-field>
                                </v-card-title>
                            </v-col>
                            <v-col>
                                <v-combobox v-model="header" :items="shift_headers" :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'" label="Start Shift" :rules="[
                                        v => !!v || 'Start Shift is required'
                                    ]" auto-select-first required></v-combobox>
                            </v-col>
                            <v-col>
                                <v-combobox v-model="header2" :items="shift_headers" :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'" label="End Shift" :rules="[
                                        v => !!v || 'End Shift is required'
                                    ]" auto-select-first required></v-combobox>
                            </v-col>
                            <v-col cols="1" class="mt-3">
                                <v-icon large @click="refreshPending">mdi-filter</v-icon>
                            </v-col>
                            <v-col class="mt-3">
                                <v-btn class="pa-2 my-3  ml-2" color="primary" small @click="validate(2)">
                                    Runout
                                    <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                </v-btn>
                                <v-btn class="pa-2 my-3 ml-2" color="primary" small @click="validate(1)">
                                    SafeFill
                                    <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col class="mt-3">
                                <v-btn class="pa-2 my-3 ml-2" color="primary" small @click="validate(5)">
                                    Retain
                                    <v-icon class="ml-2 mr-2" small>mdi-printer</v-icon>
                                </v-btn>
                                <v-btn class="pa-2 my-3 ml-2" @click="openPrediction" color="primary" small>Prediction
                                    <v-icon class="ml-2 mr-2" small>mdi-eye</v-icon></v-btn>
                                <v-btn class="pa-2 my-3 ml-2" color="primary" small @click="printMissings()">
                                    Missing Readings
                                </v-btn>
                            </v-col>
                            <v-col class="mt-4 mr-3">
                                <v-btn small @click="refreshTempPendingOrders()">Refresh Readings</v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters style="margin-top: -48px">
                            <v-col class="ml-4" cols="2" margin>
                                <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                                    :item-value="'PrincipalRegionID'" label="Select Region"
                                    auto-select-first></v-combobox>
                            </v-col>
                            <v-col style="margin-left: 10px;">
                                <v-btn class="pa-2 my-3 ml-2" color="primary" small @click="onOrdersFormClose" v-if="
                                    currentUserApp == 'glarivee' ||
                                    currentUserApp == 'fchavarin'
                                ">
                                    Show Order Summary
                                    <v-icon class="ml-2 mr-2" small>mdi-eye</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn color="primary" class="float-right mr-10" @click="multiOrders" small>Create To
                                    Line Up</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </template>

            <template v-slot:item.SiteNum="{ item }">
                <td @click="openSitemap(item)" style="cursor: pointer;">
                    {{ item.SiteNum }}
                </td>
            </template>
            <template v-slot:item.StatDailyConsumption="{ item }">
                <td>{{ Number(item.StatDailyConsumption).toFixed(0) }}</td>
            </template>

            <template v-slot:item.StatHourlyConsumption="{ item }">
                <td>{{ Number(item.StatHourlyConsumption).toFixed(0) }}</td>
            </template>
            <template v-slot:item.Check="{ item }">
                <v-checkbox dense v-model="item.Check" @change="checkend(item.Check)" :value="item.Check"></v-checkbox>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon @click="createOrder(item)">mdi-open-in-new</v-icon>
            </template>
            <template v-slot:item.show="{ item }">
                <v-icon @click="siteCheck(item)">mdi-eye-outline</v-icon>
            </template>

            <template v-slot:item.ROHrs="{ item }">
                <v-icon color="red" v-if="item.ROHrs < 4">mdi-circle</v-icon>
                <v-icon color="#DE9626" v-if="item.ROHrs > 3 && item.ROHrs < 11">mdi-circle</v-icon>
                <v-icon color="success" v-if="item.ROHrs > 10">mdi-circle</v-icon>
                {{ item.ROHrs }}
            </template>

            <template v-slot:item.safe_runout_countdown="{ item }">
                <span :style="{
                    color: getRunoutColor(item.safe_runout_at)
                }">
                    {{ timeUntil(item.safe_runout_at, 'HH') }}
                </span>
            </template>
        </v-data-table>

        <v-dialog max-width="1000" v-model="SiteDialog" transition="dialog-bottom-transition" overlay-color="accent">
            <v-toolbar dark color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>Site # {{ shiftSelected }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn icon dark @click="SiteDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <SiteReadings :onlyShow="true" />
            </v-card>
        </v-dialog>

        <v-dialog max-width="1000" v-model="showSitemap" transition="dialog-bottom-transition" overlay-color="accent"
            persistent>
            <v-toolbar dark color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>Sitemap {{ currItemSitemap.SiteNum }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="showSitemap = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <iframe :src="currItemSitemap.SitemapLink" style="width: 100%; height:100vh;"></iframe>
            </v-card>
        </v-dialog>

        <v-dialog v-model="missingDialog" transition="dialog-bottom-transition" overlay-color="accent">
            <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Missing Readings</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn icon dark @click="missingDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <v-data-table :headers="headers" :items="missing" :search="search" class="elevation-10"
                    :loading="dataLoading" :items-per-page="13" loading-text="Loading... Please wait">
                </v-data-table>
            </v-card>
        </v-dialog>

        <OrdersForm @close="onOrdersFormClose" :siteData="SiteData" :CurrentUser="currentUserApp" :DateRange="DateRange"
            v-if="$store.state.order.rdnAdd" />
        <MultiReadings :preOrders="preOrders" v-if="$store.state.readings.multiple"></MultiReadings>

        <v-dialog v-model="showGlenShiftSummary" fullscreen persistent>
            <v-card>
                <v-card-title style="padding: 30px;">
                    <span class="headline">Dispatch
                        {{
                            DateRange.End
                                ? DateRange.End.Date + ' ' + DateRange.End.Shift
                                : ''
                        }}</span>
                    <v-btn outlined left style="margin-left: 20px;" color="success" @click="downloadGlenShiftSummary">
                        Download Report
                        <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined style="margin-left: 20px;" icon left @click="showGlenShiftSummary = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col v-for="(shift, index) in glenShiftSummary" :key="index" cols="12" md="4">
                                <v-card style="height: 100%;">
                                    <v-row style="padding: 10px;">
                                        <v-col cols="6" style="margin: 0;padding: 0;">
                                            <v-card-title>{{
                                                shift.Driver
                                                }}</v-card-title>
                                        </v-col>
                                        <v-col cols="3" style="margin: 20px 0 0;padding: 0;">
                                            <p>
                                                <strong>Truck:</strong>
                                                {{ shift.Truck }}
                                            </p>
                                        </v-col>
                                        <v-col cols="3" style="margin: 20px 0 0;padding: 0;">
                                            <p>
                                                <strong>Trailer:</strong>
                                                {{ shift.Trailer }}
                                            </p>
                                        </v-col>
                                    </v-row>
                                    <v-card-text>
                                        <v-row v-for="order in shift.Orders" :key="order.OrderID"
                                            style="margin: 10px;border: 1px solid #2471a3;border-radius: 5px;padding: 15px;">
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-text-field v-model="order.LoadNum" label="LoadNum" outlined dense
                                                        hide-details @change="
                                                            updateOrderByGlen(
                                                                order
                                                            )
                                                            "></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field v-model="order.LoadNumOrd
                                                        " label="LoadNumOrd" outlined dense hide-details @change="
                                                            updateOrderByGlen(
                                                                order
                                                            )
                                                            "></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field v-model="order.StationNumber
                                                        " label="SiteNumber" outlined readonly dense
                                                        hide-details></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="4" v-for="(product,
                                                    index) in order.Products" :key="index">
                                                    <v-text-field v-model="product.Quantity
                                                        " :label="product.Product" outlined dense hide-details
                                                        :prepend="product.Product
                                                            " @change="
                                                                updateOrderDetailByGlen(
                                                                    product
                                                                )
                                                                "></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <forcastconsumption v-if="openDialogPrediction" :openDialogPrediction="openDialogPrediction"
            @close="openDialogPrediction = false;"></forcastconsumption>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import OrdersForm from './../Modals/Dispatch/Orders/AddOrderReadings.vue';
import SiteReadings from './../Modals/Dispatch/Readings/SiteReadings.vue';
import MultiReadings from './../Modals/Dispatch/Orders/MultiAddReadings.vue';
import forcastconsumption from './../Dispatch/ForcastComspution.vue';

import { dateUtils } from '../mixins/dateUtils';
export default {
    name: 'Readings',
    components: {
        OrdersForm,
        SiteReadings,
        MultiReadings,
        forcastconsumption
    },
    mixins: [dateUtils],
    data: function () {
        return {
            currItemSitemap: {},
            showSitemap: false,
            preOrders: [],
            valid: false,
            dialog: false,
            SiteDialog: false,
            missingDialog: false,
            header: null,
            header2: null,
            region: null,
            regions: [],
            shiftSelected: '',
            shift_headers: [],
            readings: [],
            missing: [],
            count: 0,
            timer: null,
            headers: [
                { text: 'RRO Hrs', value: 'ROHrs', width: '5%' },
                {
                    text: 'NRO Hrs',
                    value: 'safe_runout_countdown',
                    width: '5%'
                },
                { text: 'Site #', value: 'SiteNum', width: '7%' },
                { text: 'Station', value: 'Station', width: '7%' },
                { text: 'Product', value: 'Product', width: '6%' },
                { text: 'Volume', value: 'Volume', width: '7%' },
                { text: 'Ullage', value: 'Ullage', width: '7%' },
                { text: 'Avg Daily', value: 'AvgDaily', width: '4%' },
                { text: 'Stat Avg Daily', value: 'StatDailyConsumption', width: '4%' },
                { text: 'Avg Hourly', value: 'AvgHourly', width: '4%' },
                { text: 'Stat Avg Hourly', value: 'StatHourlyConsumption', width: '4%' },
                { text: 'ROHrs', value: 'ROHrs2', width: '5%' },
                { text: 'Reading Dttm', value: 'ReadingTime', width: '10%' },
                { text: 'Date RO', value: 'DateROHrs', width: '10%' },
                { text: 'Pend Qty', value: 'DispatchedQuantity', width: '4%' },
                { text: 'Pend Shift', value: 'Shift', width: '13%' },
                { text: 'Order', value: 'OrderID', width: '1%' },
                { text: 'L1', value: 'LoadNum', width: '1%' },
                { text: 'L2', value: 'LoadNumOrd', width: '1%' },
                { text: 'Driver', value: 'Name', width: '20%' },
                { text: 'Check', value: 'Check', width: '3%' },
                {
                    text: 'View',
                    value: 'show',
                    sortable: false,
                    width: '3%'
                },
                {
                    text: 'New',
                    value: 'actions',
                    sortable: false,
                    width: '3%'
                }
            ],
            SiteData: [],
            search: '',
            dataLoading: false,
            pendingDataLoading: false,
            currentUserApp: null,
            DateRange: {
                Start: null,
                End: null
            },
            glenShiftSummary: [],
            showGlenShiftSummary: false,
            openDialogPrediction: false,
        };
    },

    mounted() {
        this.getCurrentUser();
        this.loadShiftHeaders();
        this.loadRegions();
    },
    watch: {
        header: function () {
            this.DateRange.Start = this.header;
        },
        header2: function () {
            this.DateRange.End = this.header2;
        }
    },
    computed: {
        filteredItems() {
            // Get the current time
            const now = new Date();

            return this.readings
                .filter(i => {
                    return (
                        !this.search ||
                        i.SiteNum.toString().match(this.search) ||
                        i.Station.toString().match(this.search.toUpperCase())
                    );
                })
                .map(i => {
                    const safeRunoutAt = new Date(i.safe_runout_at);

                    const diffInMilliseconds = safeRunoutAt - now;
                    const diffInHours = diffInMilliseconds / (1000 * 60 * 60); // Convert milliseconds to hours

                    return {
                        ...i,
                        safe_runout_countdown: diffInHours.toFixed(2) // Limit to 2 decimal places
                    };
                });
        }
    },
    methods: {
        openPrediction: function () {
            this.openDialogPrediction = true;
        },
        checkend: function (itm) {
            console.log(itm);
        },
        getCurrentUser: function () {
            axios
                .get('user/current', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    let user = response.data;
                    this.currentUserApp = user.email;
                    console.log(this.currentUserApp);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        openSitemap: function (item) {
            let baseURL =
                'https://s3.amazonaws.com/upt-prod-s3-eleos/SitemapsAndDipcharts/';
            let sitemapLink =
                baseURL +
                item.StationID +
                '/Sitemap-' +
                item.StationID +
                '.pdf';
            item.SitemapLink = sitemapLink;
            this.currItemSitemap = item;
            this.showSitemap = true;
            console.log(item);
        },
        loadShiftHeaders: function () {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates/15', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.shift_headers = this.filterShiftsByDate(response.data.data);
                    const todaysShift = this.getTodayShifts(this.shift_headers);

                    this.header = todaysShift[0];
                    this.header2 = todaysShift[1];
                    this.DateRange.start = this.header;
                    this.DateRange.end = this.header2;

                    this.onlyDate()
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        filterShiftsByDate(shifts) {
            const startDate = moment().subtract(30, 'days').startOf('day'); 
            const endDate = moment().add(30, 'days').endOf('day'); 

            return shifts.filter(shift => {
                const shiftDate = moment(shift.Date, 'YYYY-MM-DD'); 
                return shiftDate.isBetween(startDate, endDate, null, '[]'); 
            });
        },

        getTodayShifts(shifts) {
            const today = moment().format('YYYY-MM-DD'); // Get today's date in local time
            return shifts.filter(shift => shift.Date === today);
        },

        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    this.regions.push({
                        PrincipalRegionID: 5,
                        PrincipalRegion: 'All'
                    });
                    this.region = this.regions[3];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadReadings: function () {
            this.$store.state.isLoading = true;
            this.dataLoading = true;
            axios
                .get('ftp-readings/reads/all/n', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.readings = response.data;
                    const estTime = moment(
                        new Date().toLocaleString('en-US', {
                            timeZone: 'America/Toronto'
                        })
                    ).format('YYYY-MM-DD HH:mm:ss');
                    for (let i = 0; i < this.readings.length; i++) {
                        var readingDttm;
                        if (this.readings[i]['DateROHrs'] === null) {
                            readingDttm = moment(
                                this.readings[i]['ReadingTime']
                            ).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            readingDttm = moment(
                                this.readings[i]['DateROHrs']
                            ).format('YYYY-MM-DD HH:mm:ss');
                        }
                        this.readings[i]['Check'] = 0;
                        const realTime = moment(readingDttm).add(
                            this.readings[i]['ROHrs'],
                            'hours'
                        );
                        const fechaInicio = moment(
                            realTime,
                            'YYYY-MM-DD HH:mm:ss'
                        );
                        const fechaFin = moment(estTime, 'YYYY-MM-DD HH:mm:ss');
                        const diferenciaEnHoras = fechaInicio.diff(
                            fechaFin,
                            'hours'
                        );
                        this.readings[i]['ROHrs2'] = this.readings[i]['ROHrs'];
                        this.readings[i]['ROHrs'] = diferenciaEnHoras;
                    }
                    console.log(this.readings);
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        onlyDate: function () {
            axios
                .get(
                    '/ftp-readings/pending-orders/all/n/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.readings = response.data;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;

        },
        filterDate: function () {
            axios
                .get(
                    '/ftp-readings/reads/region/pending/' +
                    this.region.PrincipalRegionID +
                    '/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.readings = response.data;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        onlyFilter: function () {
            console.log(
                '/ftp-readings/reads/region/' + this.region.PrincipalRegionID
            );
            axios
                .get(
                    '/ftp-readings/reads/region/' +
                    this.region.PrincipalRegionID,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(async response => {
                    this.readings = response.data;
                    const estTime = moment(
                        new Date().toLocaleString('en-US', {
                            timeZone: 'America/Toronto'
                        })
                    ).format('YYYY-MM-DD HH:mm:ss');
                    for (let i = 0; i < this.readings.length; i++) {
                        var readingDttm;
                        if (this.readings[i]['DateROHrs'] === null) {
                            readingDttm = moment(
                                this.readings[i]['ReadingTime']
                            ).format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            readingDttm = moment(
                                this.readings[i]['DateROHrs']
                            ).format('YYYY-MM-DD HH:mm:ss');
                        }
                        const realTime = moment(readingDttm).add(
                            this.readings[i]['ROHrs'],
                            'hours'
                        );
                        const fechaInicio = moment(
                            realTime,
                            'YYYY-MM-DD HH:mm:ss'
                        );
                        const fechaFin = moment(estTime, 'YYYY-MM-DD HH:mm:ss');
                        const diferenciaEnHoras = fechaInicio.diff(
                            fechaFin,
                            'hours'
                        );

                        this.readings[i]['ROHrs2'] = this.readings[i]['ROHrs'];
                        this.readings[i]['ROHrs'] = diferenciaEnHoras;
                    }
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        recall: function () {
            axios
                .get(
                    '/ftp-readings/pending-orders/all/n/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.readings = response.data;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        refreshPending: function () {
            this.$store.state.isLoading = true;
            console.log(this.header);
            console.log(this.header2);
            this.dataLoading = true;
            /*//ejecuta la funcion cuando  solo las fechas estan activas
            if(this.header != null && this.header2 != null && (this.region == null || this.region == "") ){
                this.onlyDate();

            }*/
            //ejecuta la funcion cuando las fechas y region estan activos
            if (
                this.region != null &&
                this.region != '' &&
                this.header != null &&
                this.header2 != null
            ) {
                // Se verifica que no este seleccionado el parametro aLl en region ya que su id es  5
                if (this.region.PrincipalRegionID == 5) {
                    console.log(1);
                    this.onlyDate();
                } else {
                    console.log(2);
                    this.filterDate();
                }
            }
            //ejecuta la funcion cuando solo la region esta activa
            else if (this.region != null && this.region != '') {
                if (this.region.PrincipalRegionID != 5) {
                    console.log(3);
                    this.onlyFilter();
                } else {
                    console.log(4);
                    this.loadReadings();
                }
            }
            //ejecuta la funcion si ninguna de las anteriores se cumple
            else {
                this.recall;
            }
            this.$store.state.isLoading = false;
        },
        refreshTempPendingOrders: function () {
            this.$store.state.isLoading = true;

            var str = this.$store;
            str.dispatch('setSnackbar', {
                color: 'error',
                text:
                    'Sent update readings request, this process takes a few minutes.'
            });

            axios
                .get('/ftp-readings/update', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.readings = response.data;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Readings Update Complete, Refresh page'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        createOrder: function (item) {
            console.log('item', item);
            var str = this.$store;

            if (this.header == null || this.header2 == null) {
                str.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'Select a date!'
                });
                return;
            }

            this.$store.state.isLoading = true;
            this.SiteData = [];
            this.SiteData = item;
            this.$store.state.editedOrder.id = null;
            this.$store.state.siteReadings.OrderID = 0;
            this.$store.state.siteReadings.SiteNum = '';
            this.$store.state.siteReadings.SiteNum = item.SiteNum;
            // this.$store.state.editedOrder.id = null;
            // this.$store.state.editedOrder.StationID = item.StationID;
            // this.$store.state.editedOrder.StationName = item.StationName;

            this.DateRange.Start = this.header;
            this.DateRange.End = this.header2;

            console.log('Data: ', this.DateRange, this.currentUserApp);

            this.$store.state.order.rdnAdd = true;
            item = [];
            this.$store.state.isLoading = false;
        },
        siteCheck: function (value) {
            console.log(value);
            this.shiftSelected = value.SiteNum;
            this.$store.state.siteReadings.SiteNum = value.SiteNum;
            this.SiteDialog = true;
        },
        printSafeFillPdf: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get(
                    'ftp-readings/safefill-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'SafeFill PDF.pdf');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        printRunoutPdf: async function () {
            var str = this.$store;
            console.log(this.header.ShiftId + '/' + this.header2.ShiftId);
            this.$store.state.isLoading = true;
            var route = '';
            if (this.region.PrincipalRegionID == 5) {
                route =
                    'runout-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            } else {
                route =
                    'runout-report/' +
                    this.region.PrincipalRegionID +
                    '/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            }
            console.log(route);
            if (this.header['ShiftId'] != null) {
                axios({
                    url: route,
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;

                        link.setAttribute('download', 'Runout Report.pdf');

                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        this.$store.state.isLoading = false;
                    });
            }
        },
        printSafeFillReport: function (excel) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.header.ShiftId + ' ' + this.header2.ShiftId);
            axios
                .get(
                    'ftp-readings/safefill-report/excel/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    if (excel == true)
                        link.setAttribute(
                            'download',
                            'Pending Orders over SafeFill Report.xlsx'
                        );
                    else
                        link.setAttribute(
                            'download',
                            'Pending Orders over SafeFill Report.pdf'
                        );
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    this.$store.state.isLoading = false;
                });
        },

        printRunoutReport: function () {
            var str = this.$store;
            console.log(this.header);
            this.$store.state.isLoading = true;
            console.log(this.$store.state.isLoading);
            if (this.header != null && this.header2 != null) {
                axios
                    .get(
                        '/runout-report/excel/' +
                        this.header.ShiftId +
                        '/' +
                        this.header2.ShiftId,
                        {
                            responseType: 'blob',
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Runout Report.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }

                        this.$store.state.isLoading = false;
                    });
            }
            this.header = null;
            this.header2 = null;
        },
        printRetainPdf: async function () {
            var str = this.$store;
            console.log(this.header.ShiftId + '/' + this.header2.ShiftId);
            this.$store.state.isLoading = true;
            var route = '';
            if (this.region.PrincipalRegionID == 5) {
                route =
                    '/retain-report/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            } else {
                route =
                    'retain-report/' +
                    this.region.PrincipalRegionID +
                    '/' +
                    this.header.ShiftId +
                    '/' +
                    this.header2.ShiftId;
            }
            console.log(route);
            if (this.header['ShiftId'] != null) {
                axios({
                    url: route,
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;

                        link.setAttribute('download', 'Retain Report.pdf');

                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        this.$store.state.isLoading = false;
                    });
            }
        },
        getProductCode: async function (st, ProductID) {
            let params = {
                Customer: st.CustomerId,
                Terminal: st.TerminalId,
                Supplier: st.SupplierId,
                Product: ProductID
            };
            let productCode = null;
            await axios
                .post('get-product-code-number', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('productCode: ', response.data);
                    productCode = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            return productCode;
        },
        createOrderDetails: async function (OrderID, st) {
            console.log('createOrderDetails for: ', OrderID, ' from ', st);
            var str = this.$store;

            for (let prd of st.OrderDetails) {
                let prdCode = await this.getProductCode(st, prd.ProductID);
                console.log(prdCode);
                let params = {
                    OrderID: OrderID,
                    ProductType: prd.ProductID,
                    ProductCode: prdCode,
                    ProductQuantity: 0,
                    DispatchedQuantity: 0
                };

                await axios
                    .post('order-detail', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }
        },
        createOrders: function () {
            var str = this.$store;
            console.log('createOrders');
            console.log(this.preOrders);

            var currDate = new Date();
            var year = currDate.getFullYear();
            var month = currDate.getMonth() + 1;
            var day = currDate.getDate();
            var formattedDate =
                year +
                '/' +
                (month < 10 ? '0' : '') +
                month +
                '/' +
                (day < 10 ? '0' : '') +
                day;
            console.log(formattedDate);

            for (let st of this.preOrders) {
                let isSpecific = 0;
                for (const prd of st.OrderDetails) {
                    if (prd.SpecificTrailerOnly == 1) {
                        isSpecific = prd.ProductID;
                    }
                }
                console.log(isSpecific);

                var params = {
                    Station: st.StationId,
                    Customer: st.CustomerId,
                    Terminal: st.TerminalId,
                    Supplier: st.SupplierId,
                    DateRequested: formattedDate,
                    //TimeOrdered: this.editedItem.TimeOrdered,
                    DateOrdered: formattedDate,
                    LoadingNumber: st.LoadingNumber,
                    //SpecialInstructions: this.editedItem.SpecialInstructions,
                    //DispatchComments: this.editedItem.DispatchComments,
                    //SplitTypeID: this.editedItem.SplitType.SplitTypeID,
                    //NoLoadTypeID: this.editedItem.NoLoadType.NoLoadTypeID,
                    //OrderTypeID: this.editedItem.OrderType.OrderTypeID,
                    ReadyForDispatch: 1,
                    //RTHrs: SiteRTHrs,
                    //ROHrsTime: this.editedItem.ROHrsTime,
                    //RetainHrs: this.editedItem.RetainHrs,
                    isSpecific: isSpecific,
                    //Validate: this.editedItem.Validate,
                    //ROTime: moment(ROTime).format('YYYY-MM-DD HH:mm:ss'),
                    //RTTime: moment(RTTime).format('YYYY-MM-DD HH:mm:ss')
                    AutomaticCreation: 1
                };

                axios
                    .post('order', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data);
                        //this.updateLastOrder(st.StationId, response.data.OrderID);
                        await this.createOrderDetails(
                            response.data.OrderID,
                            st
                        );
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }

            str.state.isLoading = false;
            str.dispatch('setSnackbar', {
                color: 'success',
                text: 'Orders created successfully.'
            });
        },
        updateLastOrder: function (stationID, OrderID) {
            let params = {
                StationID: stationID,
                OrderID: OrderID
            };

            axios
                .put('ftp-readings/update/last-order', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        printMissings: function () {
            this.$store.state.isLoading = true;
            axios
                .get('ftp-readings/missings', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.missing = response.data;
                    console.log(response);
                    this.missingDialog = true;
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        multiOrders: async function () {
            console.log('Hola', this.readings);
            var str = this.$store;
            str.state.isLoading = true;
            var stations = this.filteredItems
                .filter(x => {
                    return x.Check == true;
                })
                .map(x => {
                    return {
                        Station: x.StationID,
                        SiteNum: x.SiteNum
                    };
                });
            console.log(stations);
            var parms = {
                Stations: this.eliminarDuplicados(stations)
            };
            await axios
                .post('order/multi/retain/orders', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.preOrders = response.data;
                    //this.$store.state.readings.multiple = true;
                    //str.state.isLoading = false;
                    this.createOrders();
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });

            //console.log(this.preOrders);
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        validate(i) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                switch (i) {
                    case 0:
                        this.refreshPending();
                        break;

                    case 1:
                        this.printSafeFillPdf();
                        break;

                    case 2:
                        this.printRunoutPdf();
                        break;

                    case 3:
                        this.printRunoutReport(true);
                        break;

                    case 4:
                        this.printSafeFillReport(true);
                        break;
                    case 5:
                        this.printRetainPdf(true);
                        break;
                }
            }
        },
        onOrdersFormClose() {
            console.log('On orders form close');
            var str = this.$store;

            if (this.DateRange.Start == null || this.DateRange.End == null) {
                str.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'You have to select a date range!'
                });
                return;
            }

            let params = {
                StartDate: this.DateRange.Start,
                EndDate: this.DateRange.End
            };

            str.state.isLoading = true;
            axios
                .post(
                    '/shift-detail/assignment/order-creation-from-readings',
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log('Response: ', response.data);
                    let shifts = response.data.Shifts;

                    let cleanedShifts = [];
                    for (let shift of shifts) {
                        let newShift = {};
                        newShift.ShiftDetail = shift.ShiftDetail;
                        newShift.Driver = shift.DriverName;
                        newShift.Truck = shift.Truck;
                        newShift.Trailer = shift.Trailer;
                        newShift.Orders = [];

                        for (let order of shift.orders_by_glen) {
                            let newOrder = {};
                            newOrder.ShiftDetail = shift.ShiftDetail;
                            newOrder.OrderID = order.OrderID;
                            newOrder.LoadNum = order.LoadNum;
                            newOrder.LoadNumOrd = order.LoadNumOrd;
                            newOrder.StationNumber = order.StationNumber;
                            newOrder.Products = [];

                            for (let product of order.order_details_glen) {
                                let newProduct = {};
                                newProduct.OrderID = order.OrderID;
                                newProduct.OrderProdID = product.OrderProdID;
                                newProduct.Product = product.ProductName;
                                newProduct.Quantity =
                                    product.DispatchedQuantity;

                                newOrder.Products.push(newProduct);
                            }

                            newShift.Orders.push(newOrder);
                        }

                        cleanedShifts.push(newShift);
                    }
                    console.log('Cleaned shifts: ', cleanedShifts);

                    this.glenShiftSummary = cleanedShifts;
                    str.state.isLoading = false;
                    this.showGlenShiftSummary = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        downloadGlenShiftSummary() {
            console.log('Download glen shift summary report');
            console.log('Glen order summary: ', this.glenShiftSummary);

            var str = this.$store;
            str.state.isLoading = true;

            let params = {
                Data: this.glenShiftSummary,
                ReportAlias:
                    'Dispatch - ' +
                    this.DateRange.End.Date +
                    ' ' +
                    this.DateRange.End.Shift
            };

            axios
                .post('/shift-detail/order-summary/glen/download', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    let filename =
                        'Dispatch - ' +
                        this.DateRange.End.Date +
                        ' ' +
                        this.DateRange.End.Shift +
                        '.xlsx';
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        updateOrderByGlen(order) {
            console.log('Order: ', order);
            var str = this.$store;
            axios
                .put('order/update/order-by-glen', order, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Response: ', response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated!'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateOrderDetailByGlen(product) {
            console.log('Product: ', product);
            var str = this.$store;
            axios
                .put('order-detail/update/order-detail-by-glen', product, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log('Response: ', response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated!'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getRunoutColor(closestRunout) {
            const now = this.getCurrentTorontoTime();
            const runoutDate = moment.tz(closestRunout, 'America/Toronto');
            const hoursUntilRunout = runoutDate.diff(now, 'hours');

            if (hoursUntilRunout <= 0) {
                return '#FF0000'; // Red for runout reached
            } else if (hoursUntilRunout <= 24) {
                return '#FF6347'; // Tomato red for 12 hours or less
            } else if (hoursUntilRunout <= 36) {
                return '#FFA500'; // Orange for 12-24 hours
            } else if (hoursUntilRunout <= 48) {
                return '#A1D32C'; // Light yellow for 24-48 hours
            } else {
                return '#33A133'; // Light green for more than 48 hours
            }
        },

        getCurrentTorontoTime() {
            return moment().tz('America/Toronto');
        }
    }
};
</script>
